import Translation from 'dcode/classes/Translation'

export default Translation
